import React from 'react'

const loginForm = ({form,handler,submit,children, register}) =>{
    return <form onSubmit={submit}>
        <input
            type="email"
            placeholder="email"
            id="email"
            value={form.email}
            onChange={handler} />
        <input
            type="password"
            placeholder="password"
            id="password"
            value={form.password}
            onChange={handler} />
        {
            register && <input
                type="password"
                placeholder="confirm your password"
                id="passconfirm"
                value={form.passconfirm}
                onChange={handler} />
        }
            {children}
    </form>
}

export default loginForm


// WEBPACK FOOTER //
// ./src/ui/form/login/index.js